import * as React from "react";

function SvgIcMileage(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#ic-mileage_svg__filter0_dd)">
        <path
          d="M14.887 8.46a.148.148 0 01.221.195L12.625 12.3a.695.695 0 11-1.036-.912l3.298-2.927z"
          fill="currentColor"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.472 16.403c-.515.348-1.222.214-1.503-.341a9 9 0 1116.034.056c-.285.553-.993.682-1.506.33-.514-.351-.635-1.05-.374-1.614.304-.657.502-1.36.582-2.084H18a.75.75 0 010-1.5h.706a6.746 6.746 0 00-1.38-3.393l-.381.38a.75.75 0 01-1.061-1.06l.394-.395a6.74 6.74 0 00-3.528-1.487V6a.75.75 0 01-1.5 0v-.705a6.747 6.747 0 00-3.461 1.433l.448.449a.75.75 0 01-1.06 1.06l-.449-.448a6.747 6.747 0 00-1.433 3.461H6a.75.75 0 010 1.5h-.705c.079.707.269 1.396.562 2.041.257.566.131 1.264-.385 1.612zM13 12a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 18c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v1A1.75 1.75 0 0115 20.75H9A1.75 1.75 0 017.25 19v-1zM9 17.75a.25.25 0 00-.25.25v1c0 .138.112.25.25.25h6a.25.25 0 00.25-.25v-1a.25.25 0 00-.25-.25H9z"
        fill="currentColor"
      />
      <defs>
        <filter
          id="ic-mileage_svg__filter0_dd"
          x={5.355}
          y={6.423}
          width={15.779}
          height={16.179}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgIcMileage;
